"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleSelectedSlotMessage = exports.RecurringSelectedSlotMessage = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _utils = require("../../../utils");
var _ = require("../..");
var _components = require("../../../components");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ARIZONA_TIMEZONE = 'America/Phoenix';

// Can't simply compare timezone strings because
// different IANA timezone strings may be in same zone functionally
// ex. there are many timezones in EST including America/New_York and America/Indianapolis
var isDifferentTimeZone = function isDifferentTimeZone(tz1, tz2) {
  return _momentTimezone.default.tz(tz1).format('z') !== _momentTimezone.default.tz(tz2).format('z');
};
var formatMomentInAlert = function formatMomentInAlert(moment) {
  return moment.format('h:mma z');
};
var DifferentTimeZoneAlertPhysician = function DifferentTimeZoneAlertPhysician(_ref) {
  var instance = _ref.instance,
    patientTimeZone = _ref.patientTimeZone,
    clinicianTimeZone = _ref.clinicianTimeZone;
  if (!patientTimeZone || !clinicianTimeZone || !isDifferentTimeZone(patientTimeZone, clinicianTimeZone)) {
    return null;
  }
  var message = "This will be scheduled at ".concat(formatMomentInAlert((0, _momentTimezone.default)(instance).tz(patientTimeZone)), " for the patient.");
  return /*#__PURE__*/_react.default.createElement(_components.Alert, {
    type: _components.AlertTypeEnum.Alert,
    className: "tw-body-sm-light"
  }, message);
};
var DifferentTimeZoneAlertTherapist = function DifferentTimeZoneAlertTherapist(_ref2) {
  var instance = _ref2.instance,
    patientTimeZone = _ref2.patientTimeZone,
    clinicianTimeZone = _ref2.clinicianTimeZone,
    isRecurringAppointment = _ref2.isRecurringAppointment;
  if (!patientTimeZone || !clinicianTimeZone || !isDifferentTimeZone(patientTimeZone, clinicianTimeZone)) {
    return null;
  }
  var message = "This will be scheduled at ".concat(formatMomentInAlert((0, _momentTimezone.default)(instance).tz(patientTimeZone)), " for the patient.").concat((patientTimeZone === ARIZONA_TIMEZONE || clinicianTimeZone === ARIZONA_TIMEZONE) && isRecurringAppointment ? ' Please note that the appointment time will change for you with Daylight Savings because you or the patient are in Arizona.' : '');
  return /*#__PURE__*/_react.default.createElement(_components.Alert, {
    type: _components.AlertTypeEnum.Alert,
    className: "tw-body-sm-light"
  }, message);
};
var DifferentTimeZoneAlertAdmin = function DifferentTimeZoneAlertAdmin(_ref3) {
  var instance = _ref3.instance,
    patientTimeZone = _ref3.patientTimeZone,
    clinicianTimeZone = _ref3.clinicianTimeZone;
  var adminTimeZone = _momentTimezone.default.tz.guess();
  var areTimeZonesDefined = patientTimeZone && clinicianTimeZone;
  var canDisplayAlert = areTimeZonesDefined && (isDifferentTimeZone(adminTimeZone, patientTimeZone) || isDifferentTimeZone(adminTimeZone, clinicianTimeZone));
  if (!canDisplayAlert) {
    return null;
  }
  var message = "This will be scheduled at ".concat(formatMomentInAlert((0, _momentTimezone.default)(instance).tz(patientTimeZone)), " for the patient and ").concat(formatMomentInAlert((0, _momentTimezone.default)(instance).tz(clinicianTimeZone)), " for the clinician.");
  return /*#__PURE__*/_react.default.createElement(_components.Alert, {
    type: _components.AlertTypeEnum.Alert,
    className: "tw-body-sm-light"
  }, message);
};
var DifferentTimeZoneAlert = function DifferentTimeZoneAlert(_ref4) {
  var momentObject = _ref4.momentObject,
    patientTimeZone = _ref4.patientTimeZone,
    clinicianTimeZone = _ref4.clinicianTimeZone,
    isRecurringAppointment = _ref4.isRecurringAppointment;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  return (0, _utils.isAdmin)(user) ? /*#__PURE__*/_react.default.createElement(DifferentTimeZoneAlertAdmin, {
    instance: momentObject,
    patientTimeZone: patientTimeZone,
    clinicianTimeZone: clinicianTimeZone
  }) : (0, _utils.isTherapist)(user) ? /*#__PURE__*/_react.default.createElement(DifferentTimeZoneAlertTherapist, {
    instance: momentObject,
    patientTimeZone: patientTimeZone,
    clinicianTimeZone: clinicianTimeZone,
    isRecurringAppointment: isRecurringAppointment
  }) : /*#__PURE__*/_react.default.createElement(DifferentTimeZoneAlertPhysician, {
    instance: momentObject,
    patientTimeZone: patientTimeZone,
    clinicianTimeZone: clinicianTimeZone
  });
};
var RecurringSelectedSlotMessage = function RecurringSelectedSlotMessage(_ref5) {
  var intervalFrequency = _ref5.intervalFrequency,
    selectedSlot = _ref5.selectedSlot,
    patientTimeZone = _ref5.patientTimeZone,
    clinicianTimeZone = _ref5.clinicianTimeZone;
  return selectedSlot ? /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col gap-y-[12px]"
  }, /*#__PURE__*/_react.default.createElement("p", null, (0, _lodash.capitalize)((0, _utils.formatRecurringFrequencyPrefix)(intervalFrequency)), ' ', (0, _utils.formatRecurringInstance)(selectedSlot.start), " starting on", ' ', selectedSlot.start.format('MMM D')), /*#__PURE__*/_react.default.createElement(DifferentTimeZoneAlert, {
    momentObject: selectedSlot.start,
    patientTimeZone: patientTimeZone,
    clinicianTimeZone: clinicianTimeZone,
    isRecurringAppointment: true
  })) : null;
};
exports.RecurringSelectedSlotMessage = RecurringSelectedSlotMessage;
var SingleSelectedSlotMessage = function SingleSelectedSlotMessage(_ref6) {
  var selectedSlot = _ref6.selectedSlot,
    patientTimeZone = _ref6.patientTimeZone,
    clinicianTimeZone = _ref6.clinicianTimeZone;
  return selectedSlot ? /*#__PURE__*/_react.default.createElement(DifferentTimeZoneAlert, {
    momentObject: selectedSlot.start,
    patientTimeZone: patientTimeZone,
    clinicianTimeZone: clinicianTimeZone,
    isRecurringAppointment: false
  }) : null;
};
exports.SingleSelectedSlotMessage = SingleSelectedSlotMessage;